//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { go } from '../../libs/router'

export default {
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick (cb, link) {
      cb && cb(this.name)
      if (link) {
        go(link, this.$router)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/form-preview/index.vue